export const irRecvDefineCodes = new Map<string, string>();
export const irSendDefineCodes = new Map<string, string>();

let _irUsed = false;
let _irEsp8266Used = false;
let _irRemoteUsed = false;
let _irMatchRawUsed = false;
let _irMatchRawBlueUsed = false;

export function irUsed(): boolean {
    return _irUsed;
}

export function irMatchRawUsed(): boolean {
    return _irMatchRawUsed;
}

export function irMatchRawBlueUsed(): boolean {
    return _irMatchRawBlueUsed;
}

export function resetIr(): void {
    _irUsed = false;
    _irEsp8266Used = false;
    _irRemoteUsed = false;
    _irMatchRawUsed = false;
    _irMatchRawBlueUsed = false;
    irRecvDefineCodes.clear();
    irSendDefineCodes.clear();
}

export function markIrEsp8266Used(): void {
    _irUsed = true;
    _irEsp8266Used = true;
}

export function markIrRemoteUsed(): void {
    _irUsed = true;
    _irRemoteUsed = true;
}

export function markIrMatchRawUsed(): void {
    _irMatchRawUsed = true;
}

export function markIrMatchRawBlueUsed(): void {
    _irMatchRawBlueUsed = true;
}

export function irIncludeCode(): string {
    const lines: string[] = [];
    if (_irEsp8266Used) {
        lines.push('#include <IRremoteESP8266.h>');
        lines.push('#include <IRrecv.h>');
        lines.push('#include <IRsend.h>');
        lines.push('#include <IRutils.h>');
    }
    if (_irRemoteUsed) {
        lines.push('#include <IRremote.h>');
    }
    return lines.length ? lines.join('\n') + '\n' : '';
}

export function irDefineCode(): string {
    if (_irRemoteUsed) {
        return '#define USECPERTICK 50\n';
    }
    return '';
}

export function irMatchRawHelperCode(): string {
    return (
        `bool matchRaw(const uint8_t *recv, int recvLen, const uint8_t *ref, int refLen) {\n` +
        `  if (abs(recvLen - refLen) > 3) return false;\n` +
        `  int len = min(recvLen, refLen);\n` +
        `  for (int i = 0; i < len; i++) {\n` +
        `    if (abs((int)recv[i] - (int)ref[i]) > (int)(ref[i] * 0.35)) return false;\n` +
        `  }\n` +
        `  return true;\n` +
        `}\n`
    );
}

export function irMatchRawHelperCodeBlue(): string {
    return (
        `bool matchRawBlue(const uint16_t *recv, int recvLen, const uint16_t *ref, int refLen) {\n` +
        `  if (abs(recvLen - refLen) > 3) return false;\n` +
        `  int len = min(recvLen, refLen);\n` +
        `  for (int i = 0; i < len; i++) {\n` +
        `    if (abs((int)recv[i] - (int)ref[i]) > (int)(ref[i] * 0.35)) return false;\n` +
        `  }\n` +
        `  return true;\n` +
        `}\n`
    );
}

export function irSendRawHelperCode(): string {
    return (
        `void sendRawLarge(IRsend &irsend, const uint32_t buf[], uint16_t len, uint16_t hz) {\n` +
        `  uint16_t chunk[200];\n` +
        `  uint16_t ci = 0;\n` +
        `  irsend.enableIROut(hz);\n` +
        `  for (uint16_t i = 0; i < len; i++) {\n` +
        `    uint32_t val = buf[i];\n` +
        `    if (val <= 65535) {\n` +
        `      chunk[ci++] = (uint16_t)val;\n` +
        `    } else {\n` +
        `      if (ci > 0) {\n` +
        `        irsend.sendRaw(chunk, ci, hz);\n` +
        `        ci = 0;\n` +
        `      }\n` +
        `      irsend.space(val);\n` +
        `    }\n` +
        `  }\n` +
        `  if (ci > 0) irsend.sendRaw(chunk, ci, hz);\n` +
        `}\n`
    );
}
